<script lang="ts">
	import DefaultContentContainer from '$lib/components/DefaultContentContainer.svelte';
	import LoadingIndicator from '$lib/components/LoadingIndicator.svelte';
	import { _, locale } from 'svelte-i18n';
	import { browser } from '$app/environment';
	import { onMount } from 'svelte';
	import { signIn } from '@auth/sveltekit/client';

	onMount(async () => {
		await signIn('salesforce', { callbackUrl: `/${$locale}/auth/post-login` });
	});
</script>

<svelte:head>
	<title>{$_('pages.auth.login.title')} &mdash; {$_('page.title')}</title>
</svelte:head>

<DefaultContentContainer>
	{#if browser}
		<h1>{$_('pages.auth.login.title')}</h1>
		<LoadingIndicator text={$_('pages.auth.login.message')} />
	{:else}
		<p>{$_('pages.auth.login.enableJavaScript')}</p>
	{/if}
</DefaultContentContainer>
